import React, { HTMLAttributes } from 'react';

export interface HStackProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export const HStack = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>((props, ref) => {
  return (
    <div ref={ref} {...props} className={`flex ${props.className ?? ''}`}>
      {props.children}
    </div>
  );
});
